/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Mix_HelpInputs */

const en_audio_description_export_automix_mix_help = /** @type {(inputs: Audio_Description_Export_Automix_Mix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance between original and compressed audio (0-1)`)
};

const fr_audio_description_export_automix_mix_help = /** @type {(inputs: Audio_Description_Export_Automix_Mix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équilibre entre l'audio original et compressé (0-1)`)
};

const de_audio_description_export_automix_mix_help = /** @type {(inputs: Audio_Description_Export_Automix_Mix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhältnis zwischen Original- und komprimiertem Audio (0-1)`)
};

const it_audio_description_export_automix_mix_help = /** @type {(inputs: Audio_Description_Export_Automix_Mix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equilibrio tra audio originale e compresso (0-1)`)
};

const ru_audio_description_export_automix_mix_help = /** @type {(inputs: Audio_Description_Export_Automix_Mix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Баланс между исходным и сжатым аудио (0-1)`)
};

const es_audio_description_export_automix_mix_help = /** @type {(inputs: Audio_Description_Export_Automix_Mix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equilibrio entre audio original y comprimido (0-1)`)
};

const zh_cn2_audio_description_export_automix_mix_help = /** @type {(inputs: Audio_Description_Export_Automix_Mix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原始音频与压缩音频之间的平衡（0-1）`)
};

const ja_audio_description_export_automix_mix_help = /** @type {(inputs: Audio_Description_Export_Automix_Mix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オリジナルオーディオと圧縮オーディオのバランス（0-1）`)
};

const hi_audio_description_export_automix_mix_help = /** @type {(inputs: Audio_Description_Export_Automix_Mix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल और संपीड़ित ऑडियो के बीच संतुलन (0-1)`)
};

const pt_pt2_audio_description_export_automix_mix_help = /** @type {(inputs: Audio_Description_Export_Automix_Mix_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equilíbrio entre áudio original e comprimido (0-1)`)
};

/**
* | output |
* | --- |
* | "Balance between original and compressed audio (0-1)" |
*
* @param {Audio_Description_Export_Automix_Mix_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_mix_help = /** @type {((inputs?: Audio_Description_Export_Automix_Mix_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Mix_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_mix_help(inputs)
	if (locale === "de") return de_audio_description_export_automix_mix_help(inputs)
	if (locale === "it") return it_audio_description_export_automix_mix_help(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_mix_help(inputs)
	if (locale === "es") return es_audio_description_export_automix_mix_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_mix_help(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_mix_help(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_mix_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_mix_help(inputs)
	return en_audio_description_export_automix_mix_help(inputs)
});